(function () {
  var menu = document.querySelector('[data-menu]');
  var overlay = document.querySelector('[data-menu-overlay]');
  var openMenu = document.querySelector('[data-menu-open]');

  if (!menu || !overlay || !openMenu) return;

  /*
   * ---------------------------------------------------------
   * MOBILE MENU SPACING
   * ---------------------------------------------------------
   *
   * This only affects mobile menu navigation links.
   *
   * Direct links:
   * DRESS
   * SHIRTS & TOPS
   * SETS
   *
   * Nested links:
   * BAGS
   * SCARVES
   * SHAWLS
   *
   * Both use exactly the same vertical spacing.
   *
   * Image captions such as SHOP ALL are NOT affected.
   */
  function addMobileMenuStyles() {
    if (document.getElementById('pa-mobile-menu-fix-styles')) return;

    var style = document.createElement('style');
    style.id = 'pa-mobile-menu-fix-styles';

    style.textContent = `
      @media screen and (max-width: 989px) {

        /*
         * Direct links inside a menu such as WOMEN
         */
        .menu-mobile-root .menu-mobile-direct-link {
          display: block;
          width: 100%;
          box-sizing: border-box;
          padding-top: 5px;
          padding-bottom: 5px;
          margin: 0;
        }

        /*
         * Final links inside a nested menu,
         * e.g. Accessories > Her > Bags
         */
        .menu-mobile-grandpanel__links > a {
          display: block;
          width: 100%;
          box-sizing: border-box;
          padding-top: 5px;
          padding-bottom: 5px;
          margin: 0;
        }

        /*
         * Keep first/last item clean.
         */
        .menu-mobile-root .menu-mobile-direct-link:first-child,
        .menu-mobile-grandpanel__links > a:first-child {
          margin-top: 0;
        }

        .menu-mobile-root .menu-mobile-direct-link:last-child,
        .menu-mobile-grandpanel__links > a:last-child {
          margin-bottom: 0;
        }
      }
    `;

    document.head.appendChild(style);
  }

  addMobileMenuStyles();

  /*
   * ---------------------------------------------------------
   * FEATURE IMAGES
   * ---------------------------------------------------------
   */
  var featureByTitle = {
    women: {
      image:
        'https://cdn.shopify.com/s/files/1/0696/0257/4504/files/New_Project.webp?v=1782811964',
      alt: 'Pooja Aggarwal dresses',
      label: 'Shop All',
      url: '/collections/all'
    },

    accessories: {
      image:
        'https://cdn.shopify.com/s/files/1/0696/0257/4504/files/002.jpg?v=1783075733',
      alt: 'Pooja Aggarwal bags',
      label: 'Shop All',
      url: '/collections/accessories'
    }
  };

  var triggers = menu.querySelectorAll('[data-menu-panel-trigger]');
  var panels = menu.querySelectorAll('[data-menu-panel]');

  var lastTrigger = null;
  var lastMobileTrigger = null;

  /*
   * ---------------------------------------------------------
   * ICON
   * ---------------------------------------------------------
   */
  function icon(direction) {
    var path =
      direction === 'back'
        ? 'm7 1-4 4 4 4'
        : 'm3 1 4 4-4 4';

    return (
      '<svg aria-hidden="true" focusable="false" fill="none" viewBox="0 0 10 10">' +
      '<path d="' +
      path +
      '" stroke="currentColor" stroke-linecap="square"></path>' +
      '</svg>'
    );
  }

  /*
   * ---------------------------------------------------------
   * FEATURE IMAGE
   * ---------------------------------------------------------
   */
  function buildFeature(panel, feature) {
    if (!feature) return;

    if (panel.querySelector('.menu-subpanel__feature')) return;

    var anchor = document.createElement('a');

    anchor.className = 'menu-subpanel__feature';
    anchor.href = feature.url;

    anchor.innerHTML =
      '<img src="' +
      feature.image +
      '" alt="' +
      feature.alt +
      '" width="1200" height="1600" loading="lazy">' +
      '<span class="menu-subpanel__feature-label">' +
      feature.label +
      '</span>';

    panel.appendChild(anchor);
  }

  /*
   * ---------------------------------------------------------
   * MOBILE PANEL BUILDER
   * ---------------------------------------------------------
   *
   * Handles BOTH:
   *
   * 1. Direct menu links
   *
   *    WOMEN
   *      DRESS
   *      SHIRTS & TOPS
   *      SETS
   *      RESORT
   *      JACKETS
   *
   *
   * 2. Grouped / nested links
   *
   *    ACCESSORIES
   *      HER >
   *
   *        BAGS
   *        SCARVES
   *        SHAWLS
   */
  function buildMobilePanel(panel) {
    var content = panel.querySelector('.menu-subpanel__content');

    if (!content) return;

    if (panel.querySelector('.menu-mobile-root')) return;

    var root = document.createElement('div');
    var grandpanels = document.createElement('div');

    root.className = 'menu-mobile-root';

    grandpanels.className =
      'menu-mobile-grandpanels';

    /*
     * Go through everything inside
     * desktop menu content.
     */
    Array.prototype.forEach.call(
      content.children,
      function (group, groupIndex) {

        /*
         * -------------------------------------------------
         * DIRECT LINK
         * -------------------------------------------------
         *
         * Example:
         *
         * <a>DRESS</a>
         *
         * Previously this disappeared on mobile.
         */
        if (
          group.matches &&
          group.matches('a')
        ) {
          var directLink =
            group.cloneNode(true);

          directLink.classList.add(
            'menu-mobile-direct-link'
          );

          root.appendChild(directLink);

          return;
        }

        /*
         * Search for group heading.
         */
        var heading =
          group.querySelector(
            '.menu-subhead'
          );

        /*
         * Child links inside this group.
         */
        var links =
          group.querySelectorAll(
            'a:not(.menu-subhead)'
          );

        /*
         * -------------------------------------------------
         * NO HEADING / NO DROPDOWN
         * -------------------------------------------------
         *
         * If a wrapper exists but it doesn't have
         * a menu heading, its links should still be
         * shown directly.
         */
        if (!heading) {
          Array.prototype.forEach.call(
            group.querySelectorAll('a'),
            function (link) {
              var clonedLink =
                link.cloneNode(true);

              clonedLink.classList.add(
                'menu-mobile-direct-link'
              );

              root.appendChild(
                clonedLink
              );
            }
          );

          return;
        }

        /*
         * -------------------------------------------------
         * HEADING WITH NO CHILD ITEMS
         * -------------------------------------------------
         *
         * Treat heading as normal menu link.
         */
        if (!links.length) {
          var headingLink =
            heading.cloneNode(true);

          headingLink.classList.add(
            'menu-mobile-direct-link'
          );

          root.appendChild(
            headingLink
          );

          return;
        }

        /*
         * -------------------------------------------------
         * REAL DROPDOWN / ACCORDION
         * -------------------------------------------------
         */
        var id =
          panel.id +
          '-mobile-group-' +
          groupIndex;

        var control =
          document.createElement(
            'button'
          );

        control.type =
          'button';

        control.className =
          'menu-mobile-accordion';

        control.setAttribute(
          'aria-controls',
          id
        );

        control.setAttribute(
          'aria-expanded',
          'false'
        );

        control.setAttribute(
          'data-menu-mobile-accordion',
          id
        );

        control.innerHTML =
          '<span>' +
          heading.textContent.trim() +
          '</span>' +
          icon('forward');

        root.appendChild(
          control
        );

        /*
         * Build third-level panel.
         */
        var grandpanel =
          document.createElement(
            'section'
          );

        grandpanel.className =
          'menu-mobile-grandpanel';

        grandpanel.id =
          id;

        grandpanel.setAttribute(
          'aria-hidden',
          'true'
        );

        grandpanel.setAttribute(
          'data-menu-mobile-grandpanel',
          ''
        );

        /*
         * Back button + heading
         */
        var head =
          document.createElement(
            'button'
          );

        head.type =
          'button';

        head.className =
          'menu-mobile-grandpanel__head';

        head.setAttribute(
          'data-menu-mobile-grand-back',
          ''
        );

        head.innerHTML =
          icon('back') +
          '<span>' +
          heading.textContent.trim() +
          '</span>';

        grandpanel.appendChild(
          head
        );

        /*
         * Child links
         */
        var linksContainer =
          document.createElement(
            'div'
          );

        linksContainer.className =
          'menu-mobile-grandpanel__links';

        Array.prototype.forEach.call(
          links,
          function (link) {
            var clonedLink =
              link.cloneNode(true);

            linksContainer.appendChild(
              clonedLink
            );
          }
        );

        grandpanel.appendChild(
          linksContainer
        );

        grandpanels.appendChild(
          grandpanel
        );
      }
    );

    /*
     * Add mobile structure.
     *
     * Feature image is already added separately
     * and therefore SHOP ALL is NOT affected by
     * our menu-link spacing.
     */
    panel.appendChild(root);

    panel.appendChild(
      grandpanels
    );
  }

  /*
   * ---------------------------------------------------------
   * INITIAL BUILD
   * ---------------------------------------------------------
   */
  Array.prototype.forEach.call(
    triggers,
    function (trigger) {
      var title =
        trigger.textContent
          .trim()
          .toLowerCase();

      var panel =
        document.getElementById(
          trigger.getAttribute(
            'data-menu-panel-trigger'
          )
        );

      if (!panel) return;

      /*
       * Existing desktop feature.
       */
      buildFeature(
        panel,
        featureByTitle[title]
      );

      /*
       * Mobile menu.
       */
      buildMobilePanel(panel);
    }
  );

  /*
   * ---------------------------------------------------------
   * CLOSE THIRD LEVEL
   * ---------------------------------------------------------
   */
  function closeGrandPanel(
    restoreFocus
  ) {
    var active =
      menu.querySelector(
        '[data-menu-mobile-grandpanel].is-active'
      );

    if (!active) return;

    var control =
      menu.querySelector(
        '[data-menu-mobile-accordion="' +
          active.id +
          '"]'
      );

    active.classList.remove(
      'is-active'
    );

    active.setAttribute(
      'aria-hidden',
      'true'
    );

    if (control) {
      control.setAttribute(
        'aria-expanded',
        'false'
      );
    }

    menu.classList.remove(
      'is-grandchild-open'
    );

    if (
      restoreFocus &&
      control
    ) {
      control.focus();
    }
  }

  /*
   * ---------------------------------------------------------
   * CLOSE SECOND LEVEL
   * ---------------------------------------------------------
   */
  function closePanel(
    restoreFocus
  ) {
    closeGrandPanel(false);

    menu.classList.remove(
      'is-submenu-open'
    );

    Array.prototype.forEach.call(
      triggers,
      function (trigger) {
        trigger.setAttribute(
          'aria-expanded',
          'false'
        );
      }
    );

    Array.prototype.forEach.call(
      panels,
      function (panel) {
        panel.classList.remove(
          'is-active'
        );

        panel.setAttribute(
          'aria-hidden',
          'true'
        );
      }
    );

    if (
      restoreFocus &&
      lastTrigger
    ) {
      lastTrigger.focus();
    }
  }

  /*
   * ---------------------------------------------------------
   * MAIN MENU OPEN / CLOSE
   * ---------------------------------------------------------
   */
  function setMenu(open) {
    menu.classList.toggle(
      'is-open',
      open
    );

    menu.setAttribute(
      'aria-hidden',
      open
        ? 'false'
        : 'true'
    );

    overlay.setAttribute(
      'aria-hidden',
      open
        ? 'false'
        : 'true'
    );

    openMenu.setAttribute(
      'aria-expanded',
      open
        ? 'true'
        : 'false'
    );

    document.body.classList.toggle(
      'pa-menu-open',
      open
    );

    if (!open) {
      closePanel(false);
    }
  }

  /*
   * ---------------------------------------------------------
   * OPEN SECOND LEVEL
   * ---------------------------------------------------------
   *
   * WOMEN
   * ACCESSORIES
   * ETC.
   */
  function openPanel(trigger) {
    var panel =
      document.getElementById(
        trigger.getAttribute(
          'data-menu-panel-trigger'
        )
      );

    if (!panel) return;

    lastTrigger =
      trigger;

    closeGrandPanel(false);

    Array.prototype.forEach.call(
      panels,
      function (item) {
        var active =
          item === panel;

        item.classList.toggle(
          'is-active',
          active
        );

        item.setAttribute(
          'aria-hidden',
          active
            ? 'false'
            : 'true'
        );
      }
    );

    Array.prototype.forEach.call(
      triggers,
      function (item) {
        item.setAttribute(
          'aria-expanded',
          item === trigger
            ? 'true'
            : 'false'
        );
      }
    );

    menu.classList.add(
      'is-submenu-open'
    );

    window.setTimeout(
      function () {
        var back =
          panel.querySelector(
            '[data-menu-back]'
          );

        if (back) {
          back.focus();
        }
      },
      360
    );
  }

  /*
   * ---------------------------------------------------------
   * OPEN THIRD LEVEL
   * ---------------------------------------------------------
   */
  function openGrandPanel(
    trigger
  ) {
    var grandpanel =
      document.getElementById(
        trigger.getAttribute(
          'data-menu-mobile-accordion'
        )
      );

    if (!grandpanel) return;

    lastMobileTrigger =
      trigger;

    var active =
      menu.querySelector(
        '[data-menu-mobile-grandpanel].is-active'
      );

    if (
      active &&
      active !== grandpanel
    ) {
      active.classList.remove(
        'is-active'
      );

      active.setAttribute(
        'aria-hidden',
        'true'
      );

      var oldControl =
        menu.querySelector(
          '[data-menu-mobile-accordion="' +
            active.id +
            '"]'
        );

      if (oldControl) {
        oldControl.setAttribute(
          'aria-expanded',
          'false'
        );
      }
    }

    grandpanel.classList.add(
      'is-active'
    );

    grandpanel.setAttribute(
      'aria-hidden',
      'false'
    );

    trigger.setAttribute(
      'aria-expanded',
      'true'
    );

    menu.classList.add(
      'is-grandchild-open'
    );

    window.setTimeout(
      function () {
        var back =
          grandpanel.querySelector(
            '[data-menu-mobile-grand-back]'
          );

        if (back) {
          back.focus();
        }
      },
      280
    );
  }

  /*
   * ---------------------------------------------------------
   * CLICK EVENTS
   * ---------------------------------------------------------
   */
  document.addEventListener(
    'click',
    function (event) {
      var target =
        event.target;

      /*
       * OPEN MAIN MENU
       */
      if (
        target.closest(
          '[data-menu-open]'
        )
      ) {
        event.preventDefault();

        event.stopImmediatePropagation();

        setMenu(true);

        return;
      }

      /*
       * CLOSE MAIN MENU / OVERLAY
       */
      if (
        target.closest(
          '[data-menu-close]'
        ) ||
        target.closest(
          '[data-menu-overlay]'
        )
      ) {
        event.preventDefault();

        event.stopImmediatePropagation();

        setMenu(false);

        openMenu.focus();

        return;
      }

      /*
       * OPEN WOMEN / ACCESSORIES
       */
      var trigger =
        target.closest(
          '[data-menu-panel-trigger]'
        );

      if (trigger) {
        event.preventDefault();

        event.stopImmediatePropagation();

        openPanel(trigger);

        return;
      }

      /*
       * BACK TO MAIN MENU
       */
      if (
        target.closest(
          '[data-menu-back]'
        )
      ) {
        event.preventDefault();

        event.stopImmediatePropagation();

        closePanel(true);

        return;
      }

      /*
       * OPEN NESTED DROPDOWN
       */
      var mobileTrigger =
        target.closest(
          '[data-menu-mobile-accordion]'
        );

      if (mobileTrigger) {
        event.preventDefault();

        event.stopImmediatePropagation();

        openGrandPanel(
          mobileTrigger
        );

        return;
      }

      /*
       * BACK FROM NESTED MENU
       */
      if (
        target.closest(
          '[data-menu-mobile-grand-back]'
        )
      ) {
        event.preventDefault();

        event.stopImmediatePropagation();

        closeGrandPanel(true);

        return;
      }
    },
    true
  );

  /*
   * ---------------------------------------------------------
   * ESCAPE KEY
   * ---------------------------------------------------------
   */
  document.addEventListener(
    'keydown',
    function (event) {
      if (
        event.key !== 'Escape' ||
        !menu.classList.contains(
          'is-open'
        )
      ) {
        return;
      }

      event.preventDefault();

      event.stopImmediatePropagation();

      /*
       * Nested submenu open.
       */
      if (
        menu.classList.contains(
          'is-grandchild-open'
        )
      ) {
        closeGrandPanel(true);
      }

      /*
       * Women / Accessories panel open.
       */
      else if (
        menu.classList.contains(
          'is-submenu-open'
        )
      ) {
        closePanel(true);
      }

      /*
       * Main menu only.
       */
      else {
        setMenu(false);

        openMenu.focus();
      }
    },
    true
  );
})();